export default "__VITE_ASSET__D4qCB9RP__"